"use strict";

var _objectSpread = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/objectSpread");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var red = '#f44336';
var General = {
  red: red,
  black: '#000',
  blue: '#2196f3',
  green: '#4caf50',
  yellow: '#ffeb3b',
  yellow_heavy: '#f57f17',
  amber: '#ffc107',
  orange: '#ff9800',
  brown: '#795548',
  blue_grey: '#607d8b',
  lime: '#cddc39',
  teal: '#009688',
  cyan: '#00bcd4',
  indigo: '#3f51b5',
  purple: '#9c27b0',
  pink: '#e91e63',
  gray: 'gray',
  gray_light: '#aaa',
  wheat: 'wheat'
};
exports.default = _objectSpread({}, General, {
  primary: '#fff',
  accent: '#03dac4',
  accent_heavy: '#21c4c4',
  error: red,
  contrast: 'black',
  clear_button: '#6200ea',
  text: 'black'
});
exports.Dark = _objectSpread({}, General, {
  primary: '#282c34',
  accent: 'brown',
  error: red,
  contrast: '#eee',
  clear_button: '#6200ea',
  text: 'white'
});